import type {MenuLink} from "../entities/MenuLink";
import {myAxios} from "../util/myAxios";
import {eventUrl} from './base';

export function getMenuLinks(): Promise<MenuLink[]> {
  return myAxios()
    .then(axios => axios.get(eventUrl(`/menulinks`)))
    .then(response => response.data)
}
